import React from 'react'
import styled from '@emotion/styled'
import { AlphamapLogoThrobber } from 'src/components/alphamap-logo/throbber'

const InsightCardContentLoadingWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  max-height: 385px;
  justify-content: center;
  align-items: center;
`

type Props = {
  minHeight?: number
}

export const InsightCardContentLoading: React.FC<Props> = ({ minHeight }) => {
  return (
    <InsightCardContentLoadingWrapper style={{ minHeight }}>
      <AlphamapLogoThrobber />
    </InsightCardContentLoadingWrapper>
  )
}
